import { watch, toValue, onMounted, onUnmounted } from 'vue'

export function useLayerFetch(isVisible, { onShow, onHide = null, pollInterval = null }) {
  let intervalId = null

  const startPolling = () => {
    if (pollInterval && !intervalId) {
      intervalId = setInterval(() => {
        if (toValue(isVisible)) onShow()
      }, pollInterval)
    }
  }

  const stopPolling = () => {
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  watch(isVisible, (visible) => {
    if (visible) {
      onShow()
      startPolling()
    } else {
      stopPolling()
      onHide?.()
    }
  })

  onMounted(() => {
    if (toValue(isVisible)) {
      onShow()
      startPolling()
    }
  })

  onUnmounted(() => {
    stopPolling()
  })
}
